<template>
    <canvas ref="canvasRef" class="background-canvas"></canvas>
</template>

<script setup>
import StandaloneParticleAnimation from "~/utils/classes/StandaloneParticleAnimation";
import AnimationManager from "~/utils/classes/AnimationManager";

const canvasRef = ref(null);

const setCanvasSize = (canvas, mutationList = []) => {
    const HEADER_HEIGHT = window.innerWidth > 1280 || window.innerWidth < 800 ? 20 : 100;
    const FOOTER_HEIGHT = 530;
    canvas.width = document.body.clientWidth;
    canvas.height = document.body.clientHeight - HEADER_HEIGHT - FOOTER_HEIGHT;
    if (mutationList.length > 0) {
        canvas.style.marginBottom = -mutationList[0].contentRect.height + HEADER_HEIGHT + FOOTER_HEIGHT +
            "px";
    } else {
        canvas.style.marginBottom = -canvas.getBoundingClientRect().height + HEADER_HEIGHT +
            "px";

    }
}

onMounted(() => {
    /** @type {HTMLCanvasElement} */
    const $canvas = canvasRef.value;
    /** @type { CanvasRenderingContext2D } */
    const ctx = $canvas.getContext("2d");
    /** @type { AnimationManager } */
    let animationManager;

    /** @type { ResizeObserver } */
    const observer = new ResizeObserver((mutationList) => {
        setCanvasSize($canvas, mutationList);
        animationManager.animate();
    })
    observer.observe(document.body);

    setCanvasSize($canvas);

    function animationInit() {
        const particlesQty = window.innerWidth > 1280 ? 150 : 80;
        animationManager = new AnimationManager(
            $canvas,
            [
                new StandaloneParticleAnimation($canvas, particlesQty),
            ],
        );
        animationManager.animate();
    }

    animationInit();
});
</script>

<style scoped lang="scss">
@use "./index.scss";
</style>
